import * as React from 'react';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Switch, Input, Alert, Button } from 'antd';
import { connect } from 'react-redux';
import { FormComponentProps } from '@ant-design/compatible/lib/form/Form';
import { withRouter } from 'react-router';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import BackButton from '../back_button/BackButton';
import { fieldTechsRestCrudThunksForSupplier } from '../../thunks/field_techs_thunks';
import EmailComponentAntdV3 from '../email_component/EmailComponentAntdV3';

require('./FieldTechForm.less');

interface FieldTechFormProps extends FormComponentProps {
	creating: boolean;
	updating: boolean;
	formData: any;
	history: any;
	redirectForwardUrl?: string;
	onSuccess?: any;
	createErrors: any[];
	updateErrors: any[];
	currentUser: any;
	create: any;
	update: any;
}

class FieldTechForm extends React.Component<FieldTechFormProps, any> {
	handleSubmit = (e, submitAction) => {
		const { history, onSuccess, redirectForwardUrl, formData } = this.props;
		e.preventDefault();
		this.props.form.validateFields((err, values) => {
			if (!err) {
				const fieldTech = {
					...formData,
					...values,
					hourlyRate: values.hourlyRate ? parseFloat(values.hourlyRate) : undefined,
				};

				submitAction(fieldTech).then((record) => {
					if (redirectForwardUrl) {
						history.push(redirectForwardUrl);
					}
					if (onSuccess) {
						onSuccess(record);
					}
				});
			}
		});
	};

	render() {
		const {
			updating,
			creating,
			form,
			update,
			create,
			createErrors,
			formData,
			updateErrors,
			currentUser,
		} = this.props;
		const { getFieldDecorator } = form;
		const isUpdate = formData && formData.email !== undefined;
		const submitAction = isUpdate ? update : create;
		const submitText = isUpdate ? 'Update field technician' : 'Create field technician';
		const isLoading = updating || creating;

		getFieldDecorator('supplierFacilityId', {
			initialValue: formData.supplierFacilityId || nullSafeGet('facility.id', currentUser),
		});
		getFieldDecorator('supplierCompanyId', {
			initialValue:
				formData.supplierCompanyId || nullSafeGet('facility.supplierCompanyId', currentUser),
		});

		getFieldDecorator('id', { initialValue: formData.id });

		return (
			<Form
				layout="vertical"
				onSubmit={(e) => this.handleSubmit(e, submitAction)}
				className="supplierForm"
			>
				{createErrors.length > 0 ? (
					<Form.Item>
						<Alert message={createErrors.join(' ')} type="error" />
					</Form.Item>
				) : null}
				{updateErrors.length > 0 ? (
					<Form.Item>
						<Alert message={updateErrors.join(' ')} type="error" />
					</Form.Item>
				) : null}
				<EmailComponentAntdV3
					form={form}
					formData={formData}
					label={'Email'}
					fieldProps={{
						key: `email`,
						name: 'email',
					}}
					style={{ maxWidth: 640 }}
					disabled={formData.email ? true : false}
				/>
				<Form.Item label="Name">
					{getFieldDecorator('name', {
						initialValue: formData.name,
						rules: [{ required: true, message: 'This field is required.' }],
					})(<Input style={{ maxWidth: 640 }} disabled={formData.name ? true : false} />)}
				</Form.Item>
				<Form.Item label="Role">
					{getFieldDecorator('role', {
						initialValue: formData.role,
					})(<Input style={{ maxWidth: 640 }} />)}
				</Form.Item>
				<Form.Item label="Notes">
					{getFieldDecorator('notesOnTech', {
						initialValue: formData.notesOnTech,
					})(<Input.TextArea style={{ maxWidth: 640 }} />)}
				</Form.Item>
				<Form.Item label="Hourly Rate">
					{getFieldDecorator('hourlyRate', {
						initialValue: formData.hourlyRate,
					})(<Input style={{ maxWidth: 640 }} />)}
				</Form.Item>
				<Form.Item label="Available for work?">
					{getFieldDecorator('isAvailable', {
						initialValue: formData.isAvailable === undefined ? false : formData.isAvailable,
						valuePropName: 'checked',
					})(<Switch />)}
				</Form.Item>
				<Form.Item>
					<Button
						type="primary"
						htmlType="submit"
						loading={isLoading}
						className="contactForm__button"
					>
						{submitText}
					</Button>
					<span style={{ marginLeft: '16px' }}>
						<BackButton buttonText="Cancel" />
					</span>
				</Form.Item>
			</Form>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
	formData: ownProps.formData,
	redirectForwardUrl: ownProps.redirectForwardUrl,
	onSuccess: ownProps.onSuccess,

	createErrors: state.field_techs.createErrors,
	updateErrors: state.field_techs.updateErrors,
	creating: state.field_techs.creating,
	updating: state.field_techs.updating,
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
	update: (entity) => dispatch(fieldTechsRestCrudThunksForSupplier.update(entity)),
	create: (entity) => dispatch(fieldTechsRestCrudThunksForSupplier.create(entity)),
});

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(Form.create<FieldTechFormProps>()(FieldTechForm))
);
